module.exports = __webpack_public_path__ + "static/img/1_8_3.5d2bf093.jpg";